import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "container" ]

  connect() {
    // console.log("Hello, Athlete Athletic Links Controller here!", this.element)
    // console.log(this.containerTarget)
  }

  addLink(event) {
    fetch('/athletic_links').then(res => res.text()).then(partial => {
      this.containerTarget.insertAdjacentHTML( 'beforeend', partial );
    });
  }
}
